import { BaseSkin } from '../base/index';
import { bigPlayButtonCss } from '../default/bigPlayButton';
import { buttonOverrides } from '../default/buttonOverrides';

export class YoutubeSkin extends BaseSkin {
    get styleContents() {
        return `
.vjs-progress-control.vjs-control {
    display: block;
    width: 100%;
    position: absolute;
}

.video-js .vjs-control-bar {
    background-image: linear-gradient(0deg, #000000c7, transparent);
    background-color: transparent;
    height: 38px;
}

.video-js .vjs-play-progress:before {
    display: none;
}

.video-js .vjs-slider {
    background-color: rgba(255, 255, 255, 0.53);
}

.vjs-menu-button-popup .vjs-menu .vjs-menu-content {
    z-index: 1;
}

.video-js .vjs-progress-holder {
    margin-top: -3px !important;
}

.video-js .vjs-progress-holder,
.video-js .vjs-mute-control,
.video-js .vjs-play-control {
    z-index: 1;
}

.video-js .vjs-progress-holder .vjs-load-progress {
    background-color: rgba(255, 255, 255, 0.63);
}

.video-js .vjs-progress-holder .vjs-play-progress {
    background-color: orange;
}

.video-js button {
    font-size: 1.6em;
}

.video-js button, .video-js .vjs-time-control {
    font-size: 1.3em;
    width: 3.5em !important;
}
        `;
    }

    get styleOverrideContents() {
        const { buttons } = this.props.skinProps;
    
        return `            
            .video-js .vjs-progress-holder {
                ${buttons.progressbar === false ? 'display: none' : ''}
            }
        ` + buttonOverrides(buttons) + bigPlayButtonCss;
    }
}
